import React, { useState } from "react";
import { toast } from "../hooks/use-toast";

function RegistrationForm({ onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = { name, email, message };
    const emailContent = `Nom: ${name}\nEmail: ${email}\nMessage: ${message}`;
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/mail/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          to: "fabio.meyer@gmail.com",
          mailSubject: `[StreamYT] Nouvelle demande de ${formData.email}`,
          vendorEmail: "StreamYT <support@kadomi.shop>",
          bodyContent: {
            message: emailContent,
            email: formData.email,
          },
          type: "gencontact",
        }),
      });

      if (response.ok) {
        setSent(true);
        setTimeout(onClose, 2000);
      } else {
        throw new Error("Failed to send email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast({
        title: "Erreur",
        description:
          "Une erreur s'est produite lors de l'envoi de votre demande. Veuillez réessayer.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center text-green-600 font-semibold py-4">
        Merci pour votre inscription ! Nous vous contacterons rapidement.<br />
      </div>
    );
  }

  return (
    <form className="w-full flex flex-col gap-3" onSubmit={handleSubmit}>
      <input
        type="text"
        required
        placeholder="Nom complet"
        className="border rounded px-3 py-2"
        value={name}
        onChange={e => setName(e.target.value)}
        disabled={loading}
      />
      <input
        type="email"
        required
        placeholder="Email"
        className="border rounded px-3 py-2"
        value={email}
        onChange={e => setEmail(e.target.value)}
        disabled={loading}
      />
      <textarea
        required
        placeholder="Votre message ou lien de playlist"
        className="border rounded px-3 py-2"
        rows={3}
        value={message}
        onChange={e => setMessage(e.target.value)}
        disabled={loading}
      />
      <div className="flex gap-2 justify-center mt-2">
        <button
          type="submit"
          className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
          disabled={loading}
        >
          {loading ? "Envoi..." : "Envoyer"}
        </button>
        <button
          type="button"
          className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold"
          onClick={onClose}
          disabled={loading}
        >
          Fermer
        </button>
      </div>
    </form>
  );
}

export default RegistrationForm;
